import { Box, Typography } from '@mui/material';

export function SpecList({ children, columns = 2 }) {
    return (
        <Box
            component="dl"
            sx={{
                display: 'grid',
                m: 0,
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: `repeat(${columns}, minmax(0, 1fr))`,
                },
                columnGap: 3,
                rowGap: 2.5,
            }}
        >
            {children}
        </Box>
    );
}

export function SpecItem({ label, value, wide = false, children }) {
    const content = children ?? value;
    if (content == null || content === '') return null;

    return (
        <Box sx={{ gridColumn: wide ? '1 / -1' : 'auto', minWidth: 0 }}>
            <Typography component="dt" sx={styles.label}>{label}</Typography>
            <Typography component="dd" sx={styles.value}>{content}</Typography>
        </Box>
    );
}

const styles = {
    label: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: 'text.secondary',
        mb: 0.5,
    },
    value: {
        m: 0,
        fontSize: '0.9375rem',
        fontWeight: 500,
        lineHeight: 1.45,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
    },
};
